import React from "react";
import {
    Box,
    Grid,
    Typography,
    Stack,
    Button,
    Paper,
    TextField,
} from "@mui/material";
import FeedbackBar from "../../feedbackBar/FeedbackBar";

class ManagerSetting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            manager: { name: "", percentage: "",  profitThreshold: "" },
            feedbackBarOpen: false,
            feedbackMessage: '',
            feedbackStatus: '',
            isValid: false,
        };
    }

    componentDidMount() {
        const setting = this.props.managerSetting;
        if (setting) {
            this.setState(
                {
                    manager: {
                        name: setting.managerName || "",
                        percentage: setting.managerPercentage || "",
                        profitThreshold: setting.profitThreshold || "",
                    }
                },
                this.validateForm
            );
        }
    }

    handleManagerChange = (field, value) => {
        this.setState(
            prevState => ({
                manager: { ...prevState.manager, [field]: value },
            }),
            this.validateForm
        );
    };


    validateForm = () => {
        const { manager } = this.state;

        // Manager validation
        if (
            !manager.name ||
            manager.percentage === "" ||
            manager.percentage < 0 ||
            manager.percentage > 100 ||
            manager.profitThreshold === "" || // cannot be empty
            manager.profitThreshold == null || // handle null/undefined
            manager.profitThreshold < 0        // cannot be negative
        ) {
            this.setState({ isValid: false });
            return;
        }


        this.setState({ isValid: true });
    };

    handleSave = () => {
        const data = {
            location: this.props.managerSetting?.locationId || this.props.userInfo?.selectedLocationId,
            manager: this.state.manager,
        };

        const callback = (error, response) => {
            if (error) {
                this.openFeedbackBar('error', error);
            } else {
                this.openFeedbackBar('success', response);
            }
        };

        this.props.saveManagerSetting(data, callback);
    };

    openFeedbackBar = (status, message) => {
        this.setState({
            feedbackStatus: status,
            feedbackMessage: message,
            feedbackBarOpen: true,
        });
    };

    closeFeedbackBar = () => {
        this.setState({
            feedbackBarOpen: false,
            feedbackStatus: '',
            feedbackMessage: '',
        });
    };

    render() {
        const { manager, isValid } = this.state;

        return (
            <React.Fragment>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />

                <Box
                    sx={{
                        p: { xs: 2, sm: 4 },
                        display: "flex",
                        justifyContent: "flex-start"
                    }}
                >
                    <Paper
                        sx={{
                            p: { xs: 2, sm: 4 },
                            borderRadius: 4,
                            width: "100%",
                            maxWidth: 700,
                            textAlign: "left",
                            background: "linear-gradient(145deg, #ffffff, #f9f9f9)",
                            border: "0px solid rgba(0, 0, 0, 0.08)",
                            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)",
                        }}
                    >
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                            Manager Details
                        </Typography>

                        <Grid container spacing={2} sx={{ mb: 3 }} style={{ marginTop: '8px' }}>
                            <Grid item xs={12} sm={7}>
                                <TextField
                                    variant='outlined'
                                    fullWidth
                                    label="Manager Name"
                                    value={manager.name}
                                    onChange={(e) =>
                                        this.handleManagerChange("name", e.target.value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <TextField
                                    variant='outlined'
                                    fullWidth
                                    label="Manager %"
                                    type="number"
                                    value={manager.percentage}
                                    onChange={(e) =>
                                        this.handleManagerChange("percentage", e.target.value)
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={5}>
                                <TextField
                                    variant='outlined'
                                    fullWidth
                                    label="Profit Threshold"
                                    type="number"
                                    value={manager.profitThreshold}
                                    onChange={(e) =>
                                        this.handleManagerChange("profitThreshold", e.target.value)
                                    }
                                />
                            </Grid>
                        </Grid>

                        {/*<Typography variant="h6" fontWeight="bold" gutterBottom>*/}
                        {/*    Investor Details*/}
                        {/*</Typography>*/}

                        {/*{investors.map((inv, index) => (*/}
                        {/*    <Grid container spacing={2} key={index} sx={{ mb: 2 }} style={{ marginTop: '8px' }}>*/}
                        {/*        <Grid item xs={12} sm={5}>*/}
                        {/*            <TextField*/}
                        {/*                variant='outlined'*/}
                        {/*                fullWidth*/}
                        {/*                label="Investor Name"*/}
                        {/*                value={inv.name}*/}
                        {/*                onChange={(e) =>*/}
                        {/*                    this.handleInvestorChange(index, "name", e.target.value)*/}
                        {/*                }*/}
                        {/*            />*/}
                        {/*        </Grid>*/}
                        {/*        <Grid item xs={12} sm={5}>*/}
                        {/*            <TextField*/}
                        {/*                variant='outlined'*/}
                        {/*                fullWidth*/}
                        {/*                label="Investor %"*/}
                        {/*                type="number"*/}
                        {/*                value={inv.percentage}*/}
                        {/*                onChange={(e) =>*/}
                        {/*                    this.handleInvestorChange(index, "percentage", e.target.value)*/}
                        {/*                }*/}
                        {/*            />*/}
                        {/*        </Grid>*/}
                        {/*        <Grid item xs={12} sm={2} sx={{ display: "flex", alignItems: "center" }}>*/}
                        {/*            <IconButton*/}
                        {/*                color="error"*/}
                        {/*                onClick={() => this.removeInvestor(index)}*/}
                        {/*                disabled={investors.length === 1}*/}
                        {/*            >*/}
                        {/*                <Delete />*/}
                        {/*            </IconButton>*/}
                        {/*        </Grid>*/}
                        {/*    </Grid>*/}
                        {/*))}*/}

                        {/*<Button*/}
                        {/*    startIcon={<AddCircle />}*/}
                        {/*    variant="outlined"*/}
                        {/*    color="primary"*/}
                        {/*    onClick={this.addInvestor}*/}
                        {/*    sx={{ mb: 3 }}*/}
                        {/*>*/}
                        {/*    Add Investor*/}
                        {/*</Button>*/}

                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            justifyContent="flex-start"
                            alignItems={{ xs: "stretch", sm: "flex-start" }}
                            sx={{ mt: 3 }}
                        >
                            <Button
                                variant="contained"
                                color="success"
                                size="large"
                                onClick={this.handleSave}
                                disabled={!isValid}
                                sx={{
                                    px: { sm: 4 },
                                    py: 1.2,
                                    borderRadius: 2,
                                    width: { xs: "100%", sm: "auto" },
                                }}
                            >
                                Save
                            </Button>

                            <Button
                                variant="outlined"
                                color="error"
                                size="large"
                                onClick={this.props.isBack}
                                sx={{
                                    px: { sm: 4 },
                                    py: 1.2,
                                    borderRadius: 2,
                                    width: { xs: "100%", sm: "auto" },
                                }}
                            >
                                Cancel
                            </Button>
                        </Stack>

                    </Paper>
                </Box>
            </React.Fragment>
        );
    }
}

export default ManagerSetting;